import React, { Component } from 'react';
import PayrollSetupManager from '../campaign/PayrollSetupManager';
import {
    DKLabel,
    DKButton,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
  } from "deskera-ui-library";
  import Stepper from "../common/Stepper";
import CompanyDetailService from '../../services/CompanyDetailService';
import PayScheduleService from '../../services/PayScheduleService';
import RouteManager from '../../managers/RouteManager';
import { TENANT, TenantService } from '../../managers/TenantManagerService';
import ProfileSetupService from '../../services/ProfileSetup-service';
import { PROFILE_STAGES_CONSTANT } from '../../constants/Constant';
import TenantManager from '../../managers/TenantManager';
class PayrollSetup extends Component {
    constructor(pros){
        super(pros);
        this.steps = PayrollSetupManager.getAllCreationSteps(this.onSkipToStep);
        this.state = {
            currentStep:0,
            formFields:null,
            payScheduleFormFields:null,
            isCurrentStepValid:false
        }
    }
    
    triggerChildAlert(){
      this.refs.child.showAlert();
  }
    getCurrentStepChild() {
        const currStep = this.steps[this.state.currentStep];
        return currStep.getChild({
          state: this.state,
          tableName: this.tableName,
          ref: "child",
          setData: this.handleStepData,
          ...this.props
        });
    }
    
    handleStepData = (data, callback) => {
        if(this.state.currentStep == 0) {
            this.setState({formFields:data,isCurrentStepValid:callback});
        } else if(this.state.currentStep == 1) {
            this.renameJsonKey(data, "id", "_id");
            this.setState({payScheduleFormFields:data,isCurrentStepValid:callback})
        }
      };

      renameJsonKey(object, oldKey, newKey) {
        object[newKey] = object[oldKey];
      }

    getControllers() {
        const {  currentStep } = this.state;
        const isLastStep = currentStep === this.steps.length - 1;
        return (
          <div className="row parent-width justify-content-start mb-l">
            {currentStep !== 0 && (
              <DKButton
                title="Back"
                className="border-m mr-r bg-gray1 justify-content-start"
                onClick={(e) => this.onSkipToStep(e, currentStep - 1)}
              />
            )}
            {!isLastStep && <DKButton
              title="Next"
              className="border-m bg-app text-white"
              onClick={this.onSkipToStep}
            />}
            {isLastStep && <DKButton
              title="Finish"
              className="border-m  bg-app text-white"
              onClick={this.navigateTo}
            />}
          </div>
        );
    }
    navigateTo =()=> {
        RouteManager.navigateToPage('')
    }
    onSkipToStep = (event, index) => {
        const { currentStep } = this.state;

        /* By default expected step is to move forward */
        const expectedStep = index ?? currentStep + 1;

        /* If it's the last step */
        if (expectedStep === this.steps.length) {
          this.handleImportConfirmation();
          return;
        }

        if (this.isInvalidStep(expectedStep)) {
          const errorInfo =
            this.steps[currentStep].reqError ||
            `Sorry can't proceed, please complete the current step first`;
          showToast(errorInfo, TOAST_TYPE.FAILURE);
        } else if(this.state.isCurrentStepValid) {
            switch(currentStep) {
                case 0: // company detail
                    const params = {...this.state.formFields};
                    if (typeof params['isWorkLocation'] != 'boolean') {
                        params['isWorkLocation'] = (params['isWorkLocation'][0] == 0) ? true : false;
                    }

                    params["countryCode"] = "IN";
                    params["currency"] = "INR";
                    params["orgSetupCompleted"] = true;
                    params["compliance"] = {...params["compliance"], countryCode: "IN"};

                          CompanyDetailService.updateCompanyDetail(params)
                          .then(response=>{
                            if(response['tenant']) {
                              TenantService.set(
                                TENANT.TENANT_WORK_WEEK,
                                response['tenant']['workWeekDetails']
                              )
                              showToast(
                                `Company Detail saved successfully`,
                                TOAST_TYPE.SUCCESS
                              );
                              ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.COMPANY_DETAILS)
                              .then(res=>{
                                TenantManager.setProfileData(res['profileStages']);                    
                              })
                              this.setState({ currentStep: expectedStep });
                            }
                            
                          },error=>{
                            showToast(
                              `Internal Server Error`,
                              TOAST_TYPE.FAILURE
                            );
                          })
                          
                          
                    break;
                case 1:
                        if(this.state.payScheduleFormFields && this.state.payScheduleFormFields._id && this.state.payScheduleFormFields._id != "") {
                            PayScheduleService.updatePaySchedule(this.state.payScheduleFormFields)
                            .then(res=>{
                              showToast(
                                `Pay Schedule updated successfully`,
                                TOAST_TYPE.SUCCESS
                            );
                              ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.PAY_SCHEDULE)
                              .then(res=>{
                                TenantManager.setProfileData(res['profileStages']);                    
                            })
                            })
                        } else {
                            PayScheduleService.addPaySchedule(this.state.payScheduleFormFields)
                            .then(res=>{
                              showToast(
                                `Pay Schedule added successfully`,
                                TOAST_TYPE.SUCCESS
                            );
                              ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.PAY_SCHEDULE)
                              .then(res=>{
                                TenantManager.setProfileData(res['profileStages']);                    
                            })
                            })
                        }
                        
                        
                        this.setState({ currentStep: expectedStep });
                    break;
                default:
                    this.setState({ currentStep: expectedStep });
                    break;
            }
        } else {
          
          if(currentStep == 0 || currentStep == 1) {
            this.triggerChildAlert()
          }
          
            showToast(
                `Please fill in the required valid details`,
                TOAST_TYPE.FAILURE
            );
        }
    };
    isInvalidStep = (expectedStep) => {
        if (expectedStep < 0 || expectedStep >= this.steps.length) return false;

        /* Check if component has required data for expected step */
        const { requiredProps } = this.steps[expectedStep];
        return requiredProps.some(
          (requiredProp) => this.state[requiredProp] === null
        );
      };
    render(){
        return (
            <div className="column parent-width">
        <DKLabel text="Payroll Setup" className="fw-m fs-l mb-r" />
        <Stepper
          data={this.steps}
          currentIndex={this.state.currentStep}
          className="mb-l"
          width={200}
        />

        <div className="row parent-width m-v-xl justify-content-center">
          {this.getCurrentStepChild()}
        </div>

        {this.getControllers()}
      </div>
        )
    }
}
export default PayrollSetup;